import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { IntegrationConnectionDto } from "../dto/integrationConnection/integration-connection.dto";

const c = initContract();

export const billcomContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: z.object({
                /**
                 * Omitted when an accounting firm connects from the
                 * organization view: the connection is created without a
                 * client and its accounts are assigned afterwards.
                 */
                workspaceId: z.string().uuid().optional(),
                tokenName: z.string().min(1),
                tokenValue: z.string().min(1),
                defaultEntityId: z.coerce.number().optional(),
            }),
            responses: {
                201: c.type<IntegrationConnectionDto>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/billcom",
    },
);
